import styled from 'styled-components';
import { smallMobile } from '../utils/screenStyles';

// buttons can handle being disabled with either a prop or a class.
const Button = styled.button.attrs({
  className: props => props.disabled ? (props.className || '') + ' disabled' : (props.className)
})`
min-width: 160px;
font-variant: all-small-caps;
border: 1px solid transparent;
border-radius: 4px;
font-size: large;
text-decoration: none;
line-height: 1.5;
padding: .625rem .75rem;
cursor: pointer;
transition:
  color .15s ease-in-out,
  background-color .15s ease-in-out;

  &.disabled {
    background-color: ${props => props.theme.colors.janeGray} !important;
    cursor: auto;
    :hover{
			background: ${props => props.theme.colors.janeGray} !important;
		}
  }
  &:focus{
    outline: none;
  }

  ${smallMobile`
    min-width: 100px;
  `}
`;

export const StyledPrimaryButton = styled(Button)`
  background-color: ${props => props.theme.colors.primary} !important;
  border-color: transparent !important;
  color: #ffffff;
  :hover{
    background-color: ${props => props.theme.colors.tealDark} !important;
  }
`;

export const StyledPrimaryOutlineButton = styled(Button)`
  border-color: ${props => props.theme.colors.primary} !important;
  background-color: transparent;
  color: ${props => props.theme.colors.primary} !important;
  :hover{
    color: ${props => props.theme.colors.tealDark} !important;
    border-color:  ${props => props.theme.colors.tealDark} !important;
  }
  &.disabled{
    border-color:  ${props => props.theme.colors.janeGray} !important;
    color: ${props => props.theme.colors.janeGray} !important;
    cursor: auto;
  }
  &.disabled{
    background: #D9D9D9 !important;
    color: #FFFFFF !important;
    border: 0;
    :hover {
      background: #D9D9D9 !important;
      color: #FFFFFF !important;
      border: 0;
    }
  }
`;
